import { Suspense, useEffect, type ReactNode } from "react";
import {
  Outlet,
  useRouterState,
} from "@tanstack/react-router";

import HomePage from "@/app/page";
import OpenTaskPage from "@/app/task-list/open/page";
import TaskListClientLayout from "@/app/task-list/_components/TaskListClientLayout";
import TaskListError from "@/app/task-list/error";
import { useAuthSession } from "@/lib/auth/auth-provider";

export function RouteFallback({ label }: { label: string }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-white text-sm text-gray-500">
      {label}...
    </div>
  );
}

export function RootRouteComponent() {
  return (
    <Suspense fallback={<RouteFallback label="Cargando" />}>
      <Outlet />
    </Suspense>
  );
}

export function TaskAreaRouteComponent() {
  return (
    <TaskListClientLayout>
      <Outlet />
    </TaskListClientLayout>
  );
}

export function TaskAreaError({ error, reset }: { error: Error; reset: () => void }) {
  return <TaskListError error={error} reset={reset} />;
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, login } = useAuthSession();

  useEffect(() => {
    if (status !== "unauthenticated") return;
    const callbackUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    void login(callbackUrl);
  }, [login, status]);

  if (status !== "authenticated") return <RouteFallback label="Verificando acceso" />;
  return children;
}

export function HomeRouteComponent() {
  const searchStr = useRouterState({ select: (state) => state.location.searchStr });
  return <HomePage searchParams={new URLSearchParams(searchStr)} />;
}

export function OpenTaskRouteComponent() {
  const searchStr = useRouterState({ select: (state) => state.location.searchStr });
  return <OpenTaskPage searchParams={new URLSearchParams(searchStr)} />;
}
